import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { LawEnforcementPage } from './pages/LawEnforcementPage';
import { CrisisManagementPage } from './pages/CrisisManagementPage';
import { CorporatePage } from './pages/CorporatePage';
import { CivilianPage } from './pages/CivilianPage';
import { TrainingPage } from './pages/TrainingPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { BlogPage } from './pages/BlogPage';
import { ContactPage } from './pages/ContactPage';
import { AboutPage } from './pages/AboutPage';
import { MeetTheFounderPage } from './pages/MeetTheFounderPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/law-enforcement-capabilities" element={<LawEnforcementPage data-id="element-5" />} data-id="element-4" />
        <Route path="/crisis-management-planning" element={<CrisisManagementPage data-id="element-7" />} data-id="element-6" />
        <Route path="/corporate-critical-incidents-planning" element={<CorporatePage data-id="element-9" />} data-id="element-8" />
        <Route path="/civilian-protection" element={<CivilianPage data-id="element-11" />} data-id="element-10" />
        <Route path="/training" element={<TrainingPage data-id="element-13" />} data-id="element-12" />
        <Route path="/strategic-partners" element={<ResourcesPage data-id="element-15" />} data-id="element-14" />
        <Route path="/blog" element={<BlogPage data-id="element-17" />} data-id="element-16" />
        <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
        <Route path="/medina-tactical-dynamics" element={<AboutPage data-id="element-21" />} data-id="element-20" />
        <Route path="/meet-the-founder" element={<MeetTheFounderPage data-id="element-23" />} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}